import {
  GET_KINSHIP,
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,
} from "./actionType";

const INIT_STATE = {
  kinships: [],
  error: {},
  success: "",
};

const Kinship = (state = INIT_STATE, action) => {
  switch (action.type) {
    case API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_KINSHIP:
          return {
            ...state,
            kinships: action.payload.data.data,
            success: "",
            error: {},
          };

        default:
          return { ...state };
      }
    case API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case GET_KINSHIP:
          return {
            ...state,
            success: "",
            error: action.payload.error,
          };

        default:
          return { ...state };
      }
    case GET_KINSHIP: {
      return {
        ...state,
      };
    }

    default:
      return { ...state };
  }
};

export default Kinship;
